// extracted by mini-css-extract-plugin
export default {"QRCodesListing":"QRCodes_QRCodesListing__RmUPJ","QrCode":"QRCodes_QrCode__f9eRa","QrCodeDiv":"QRCodes_QrCodeDiv__OPi56","ag-theme-text-center":"QRCodes_ag-theme-text-center__qhpJg"};